module.exports = __webpack_public_path__ + "static/family-running-on-beach-tablet.2ed6eb48.webp";